<template>
  <span v-if="!hasFundedLoan && getMissingActionItemsCount > 0" class="action-icon-circle align-top">
    <span class="action-number">
      {{getMissingActionItemsCount}}
    </span>
  </span>
</template>

<script>
import get from 'lodash/get'
import { mapState } from 'pinia'
import { usePortalStore } from '~/store/portal'
import { useDealsStore } from '~/store/deals'

export default {
  name: 'ActionItemsBadge',
  computed: {
    ...mapState(usePortalStore, ['getMissingActionItemsCount']),
    ...mapState(useDealsStore, {
      deals: state => (get(state, 'deals') || []).slice().sort((a, b) => {
        return (new Date(b.created).getTime()) - (new Date(a.created).getTime())
      }),
    }),
    hasFundedLoan() {
      const fundedDeals = (this.deals || []).filter((deal) => {
        return (
          (!deal.autoSubmitType || ['qualified', 'vamp', 'decision_for_approval', 'decision_for_preapproval'].includes(deal.autoSubmitType)) &&
          deal.loanProductOfferType === "tier-1" &&
          deal.stage === "funded"
        );
      });

      if (!fundedDeals.length) {
        return false;
      }

      const fundedDeal = fundedDeals.at(0);

      let acceptedOffer = fundedDeal?.acceptedOffer;
      if (acceptedOffer) {
        return true;
      }

      const activeOffers = (fundedDeal?.offers || [])
        .filter((offer) => {
          return (
            Boolean(offer.accepted) ||
            Boolean(offer.borrowerAcceptedDate) ||
            Boolean(offer.offerLink)
          );
        })
        .reverse();

      return Boolean(activeOffers.length)
    }
  },
}
</script>

<style  scoped lang="scss">
.action-icon-circle {
  text-align: center;
  vertical-align: text-top;
  display: inline-block;
  position: relative;
  border-radius: 50%;
  width: 1.5em !important;
  height: 1.5em !important;

  color: $white;
  background: $red-300;
  border: 1px solid $red-300;
}

.action-number {
  font-weight: 400;
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>
